(function () {
  const PRICE_LIMIT_CENTS = 1000;
  const PROMOTION_GROUP_SIZE = 10;
  const MIN_NOTICE_QUANTITY = 2;
  const UNLOCKED_MESSAGE = '2 free rolls unlocked — add to cart!';

  function initNotice(notice) {
    const form = notice.closest('[data-product-form]');
    const pricesScript = notice.previousElementSibling;
    const selector = pricesScript && pricesScript.previousElementSibling;
    const input = selector && selector.querySelector('[data-quantity-input]');
    const message = notice.querySelector('[data-bogo-quantity-message]');

    if (!form || !selector || !selector.matches('[data-quantity-selector]') || !input || !message || !pricesScript) return;

    let variantPrices = [];

    try {
      variantPrices = JSON.parse(pricesScript.textContent);
    } catch (error) {
      return;
    }

    selector.classList.add('quantity-selector--has-bogo');
    selector.appendChild(notice);

    const productRoot = form.closest('.product--outer') || form;
    const variantInput = form.querySelector('[data-variants], [name="id"]');
    const atcButton = form.querySelector('[data-product-atc]');
    let eligible = false;

    function hasVariant(variantId) {
      return variantPrices.some(function (variant) {
        return String(variant.id) === String(variantId);
      });
    }

    function setEligibility(variantId, fallbackPrice) {
      const selected = variantPrices.find(function (variant) {
        return String(variant.id) === String(variantId);
      });
      const price = selected ? selected.price : fallbackPrice;
      const numericPrice = Number(price);

      // The variant JSON is the source of truth. Reading the visible price is
      // unreliable here because the merged template keeps desktop and mobile
      // price nodes in the DOM and one of them can briefly contain old text.
      eligible = Number.isFinite(numericPrice) && numericPrice <= PRICE_LIMIT_CENTS;
      updateNotice();
    }

    function getSelectedVariantId() {
      const customVariantSelector = productRoot.querySelector('#variantSelector');
      const selectedCustomOption = customVariantSelector && customVariantSelector.selectedOptions
        ? customVariantSelector.selectedOptions[0]
        : null;
      const currentAtcButton = form.querySelector('.customatc[var_id], [data-product-atc][data-variant-id]');
      const currentVariantInput = form.querySelector('[data-variants], [name="id"]');

      if (selectedCustomOption && selectedCustomOption.id) {
        return selectedCustomOption.id;
      }

      if (currentAtcButton) {
        return currentAtcButton.getAttribute('var_id')
          || currentAtcButton.getAttribute('data-variant-id')
          || '';
      }

      return currentVariantInput ? currentVariantInput.value : '';
    }

    function syncVariantEligibility() {
      const variantId = getSelectedVariantId();

      if (!variantId || variantId === 'not-selected') {
        eligible = false;
        updateNotice();
        return;
      }

      setEligibility(variantId);
    }

    function scheduleVariantSync() {
      // Hide immediately so a stale eligible variant can never advertise the
      // promotion while a custom variant picker is still updating its ID.
      eligible = false;
      updateNotice();
      window.requestAnimationFrame(syncVariantEligibility);
      window.setTimeout(syncVariantEligibility, 100);
      window.setTimeout(syncVariantEligibility, 250);
    }

    function updateNotice() {
      const quantity = Number.parseInt(input.value, 10) || 1;
      const remainder = quantity % PROMOTION_GROUP_SIZE;

      notice.classList.remove('bogo-quantity-notice--unlocked');

      if (!eligible || quantity < MIN_NOTICE_QUANTITY) {
        notice.hidden = true;
        return;
      }

      if (remainder >= MIN_NOTICE_QUANTITY) {
        const remainingQuantity = PROMOTION_GROUP_SIZE - remainder;

        message.textContent = quantity < PROMOTION_GROUP_SIZE
          ? `Add ${remainingQuantity} more — your 9th and 10th rolls are FREE!`
          : `Add ${remainingQuantity} more — get 2 more rolls FREE!`;
        notice.hidden = false;
        return;
      }

      if (quantity >= PROMOTION_GROUP_SIZE && remainder === 0) {
        message.textContent = UNLOCKED_MESSAGE;
        notice.classList.add('bogo-quantity-notice--unlocked');
        notice.hidden = false;
        return;
      }

      notice.hidden = true;
    }

    function scheduleNoticeUpdate() {
      updateNotice();
      window.requestAnimationFrame(updateNotice);
      window.setTimeout(updateNotice, 100);
    }

    selector.querySelectorAll('[data-quantity-plus], [data-quantity-minus]').forEach(function (button) {
      button.addEventListener('click', scheduleNoticeUpdate);
    });
    input.addEventListener('input', scheduleNoticeUpdate);
    input.addEventListener('change', scheduleNoticeUpdate);
    input.addEventListener('keyup', scheduleNoticeUpdate);

    productRoot.querySelectorAll('[data-variant-selection]').forEach(function (variantSelection) {
      variantSelection.addEventListener('variant-change', function (event) {
        const variant = event.detail && event.detail.variant;
        if (variant) setEligibility(variant.id, variant.price);
      });
    });

    window.addEventListener('tapeproviders:variant-change', function (event) {
      const variantId = event.detail && event.detail.id;

      // A merged product can contain more than one product form. Only update
      // this notice when the announced variant belongs to its own price map.
      if (variantId && hasVariant(variantId)) {
        setEligibility(variantId);
      } else {
        eligible = false;
        updateNotice();
      }
    });

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-variants], [name="id"]')) {
        setEligibility(event.target.value);
        return;
      }

      if (event.target !== input) scheduleVariantSync();
    });

    const variantObserver = new MutationObserver(function (mutations) {
      const variantChanged = mutations.some(function (mutation) {
        if (mutation.type === 'attributes') {
          return mutation.target.matches('.customatc, [data-product-atc], [data-variants], [name="id"]');
        }

        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1
            && (node.matches('.customatc, [data-product-atc], [data-variants], [name="id"]')
              || node.querySelector('.customatc, [data-product-atc], [data-variants], [name="id"]'));
        });
      });

      if (variantChanged) syncVariantEligibility();
    });

    variantObserver.observe(form, {
      attributes: true,
      attributeFilter: ['var_id', 'data-variant-id', 'value'],
      childList: true,
      subtree: true
    });

    if (atcButton && (atcButton.hasAttribute('var_id') || atcButton.hasAttribute('data-variant-id'))) {
      syncVariantEligibility();
    } else if (variantInput) {
      setEligibility(variantInput.value);
    } else {
      setEligibility(notice.dataset.bogoInitialVariantId);
    }
  }

  function initAllNotices() {
    document.querySelectorAll('[data-bogo-quantity-notice]').forEach(initNotice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllNotices);
  } else {
    initAllNotices();
  }
})();
